@if (shouldShow$ | async) {
<div class="manual-maintenance-minutes-container primary-container-rounded">
  <div class="header-section">
    <h1>Manuelle Vedligeholdelsesminutter</h1>
    @if (mode === 'location') {
    <p class="subtitle">
      Registrer manuelle vedligeholdelsesminutter og moduler for flere
      brugere på lokationen på én gang
    </p>
    } @else {
    <p class="subtitle">
      Oversigt over manuelt tilføjede vedligeholdelsesminutter
    </p>
    }
  </div>
  @if (mode === 'location') {
  <div class="location-actions">
    @if (canEdit$ | async) {
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="openBulkDialog()"
    >
      <mat-icon>group_add</mat-icon>
      Registrer for flere brugere
    </button>
    <p class="location-hint">
      Vælg uddannelsesvej, år, dato og de brugere på lokationen, der skal have
      registreret minutter/moduler. Brugere der allerede har en manuel
      registrering for samme sti og år springes over.
    </p>
    }
  </div>
  } @else { @if (loading$.value) {
  <div class="loading-container">
    <mat-icon class="spinner">hourglass_empty</mat-icon>
    <p>Indlæser data...</p>
  </div>
  } @if (error$.value) {
  <div class="error-container">
    <mat-icon>error</mat-icon>
    <p>{{ error$.value }}</p>
    <button mat-button (click)="refresh()">Prøv igen</button>
  </div>
  } @if (!loading$.value && !error$.value) {
  <div class="content-container">
    @if ((canEdit$ | async) && (userPaths$ | async)?.length) {
    <div class="profile-year-actions">
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="addEntryForProfileYear()"
      >
        <mat-icon>add</mat-icon>
        Tilføj for profilens år
      </button>
    </div>
    } @if (groupedData$ | async; as groupedData) { @if (groupedData.length ===
    0) {
    <div class="empty-state">
      <mat-icon>info</mat-icon>
      <p>Ingen manuelle vedligeholdelsesminutter registreret endnu</p>
      @if (canEdit$ | async) {
      <div class="empty-state-actions">
        <button
          mat-raised-button
          color="primary"
          (click)="addEntryFromEmptyState()"
        >
          <mat-icon>add</mat-icon>
          Tilføj manuelle vedligeholdelsesminutter
        </button>
      </div>
      }
    </div>
    } @for (yearGroup of groupedData; track yearGroup) {
    <div class="year-group">
      <div class="year-header">
        <h2>{{ yearGroup.year }}</h2>
      </div>
      @for (path of yearGroup.paths; track path) {
      <div class="path-group">
        <div class="path-header">
          <div class="path-title-section">
            <h3>{{ path.path_name }}</h3>
            @if (path.total_minutes > 0) {
            <span class="total-minutes"
              >{{ path.total_minutes }} minutter krediteret i alt</span
            >
            }
          </div>
          @if (canEdit$ | async) {
          <button
            mat-stroked-button
            color="primary"
            (click)="addEntry(yearGroup.year, path.path_id, path.path_name)"
          >
            <mat-icon>add</mat-icon>
            Tilføj for dette år
          </button>
          }
        </div>
        @if (path.entries.length > 0) {
        <div class="entries-list">
          @for (entry of path.entries; track entry) {
          <div class="entry-card">
            <div class="entry-header">
              <div class="entry-info">
                <span
                  class="minutes-badge"
                  [class.acquire-all]="entry.acquire_all_needed"
                >
                  {{
                    entry.acquire_all_needed
                      ? "—"
                      : getEntryTotalMinutes(entry) + " minutter"
                  }}
                </span>
                @if (entry.acquire_all_needed) {
                <mat-chip color="primary"> Opnået alt nødvendigt </mat-chip>
                } @if (!entry.acquire_all_needed) {
                <mat-chip [color]="getSourceColor(entry.source)">
                  {{ getSourceDisplay(entry.source) }}
                </mat-chip>
                }
              </div>
              @if (canEdit$ | async) {
              <div class="entry-actions">
                <button
                  mat-icon-button
                  (click)="editEntry(entry)"
                  matTooltip="Rediger"
                >
                  <mat-icon>edit</mat-icon>
                </button>
                <button
                  mat-icon-button
                  (click)="deleteEntry(entry)"
                  matTooltip="Slet"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              }
            </div>
            <div class="entry-details">
              @if (entry.completed_modules?.length) {
              <div class="detail-row">
                <mat-icon class="detail-icon">school</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Moduler</span>
                  <span class="detail-value">
                    @for (mod of entry.completed_modules; track mod; let last =
                    $last) {
                    <span>
                      {{ mod.module_name }} ({{
                        mod.maintenance_minutes_credited
                      }}
                      min.)@if (!last) {
                      <span>, </span>
                      }
                    </span>
                    }
                  </span>
                </div>
              </div>
              } @if (!entry.acquire_all_needed && entry.maintenance_minutes > 0)
              {
              <div class="detail-row">
                <mat-icon class="detail-icon">timer</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Ekstra minutter</span>
                  <span class="detail-value"
                    >{{ entry.maintenance_minutes }} min.</span
                  >
                </div>
              </div>
              } @if (entry.acquired_date) {
              <div class="detail-row">
                <mat-icon class="detail-icon">event_available</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Dato opnået</span>
                  <span class="detail-value">{{
                    getAcquiredDate(entry.acquired_date) | date : "dd/MM/yyyy"
                  }}</span>
                </div>
              </div>
              } @if (entry.notes) {
              <div class="detail-row">
                <mat-icon class="detail-icon">note</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Noter</span>
                  <span class="detail-value">{{ entry.notes }}</span>
                </div>
              </div>
              } @if (entry.source_id) {
              <div class="detail-row">
                <mat-icon class="detail-icon">link</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Kilde ID</span>
                  <span class="detail-value">{{ entry.source_id }}</span>
                </div>
              </div>
              }
              <div class="detail-row">
                <mat-icon class="detail-icon">person</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Tilføjet af</span>
                  <span class="detail-value">{{
                    entry.created_by_name || "Ukendt"
                  }}</span>
                </div>
              </div>
              <div class="detail-row">
                <mat-icon class="detail-icon">schedule</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Tilføjet</span>
                  <span class="detail-value">{{
                    entry.created_at | date : "dd/MM/yyyy HH:mm"
                  }}</span>
                </div>
              </div>
              @if (entry.updated_at && entry.updated_at !== entry.created_at) {
              <div class="detail-row">
                <mat-icon class="detail-icon">update</mat-icon>
                <div class="detail-content">
                  <span class="detail-label">Opdateret</span>
                  <span class="detail-value">{{
                    entry.updated_at | date : "dd/MM/yyyy HH:mm"
                  }}</span>
                </div>
              </div>
              }
            </div>
          </div>
          }
        </div>
        } @if (path.entries.length === 0) {
        <div class="no-entries">
          <p>
            Ingen manuelle vedligeholdelsesminutter for denne sti i
            {{ yearGroup.year }}
          </p>
        </div>
        }
      </div>
      }
    </div>
    } }
  </div>
  } }
</div>
}
